export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.64 7.87c.693 1.682.396 3.66-.988 5.044-1.435 1.385-3.512 1.731-5.242.89l-8.605 8.606c.84 1.73.494 3.807-.89 5.242-1.385 1.384-3.363 1.681-5.045.989l2.819-2.869c.692-.643.692-1.78 0-2.472a1.731 1.731 0 00-2.473 0l-2.868 2.868c-.692-1.681-.346-3.709.99-5.044 1.433-1.434 3.56-1.731 5.29-.94l8.556-8.555c-.791-1.731-.494-3.858.94-5.292 1.335-1.335 3.363-1.681 5.044-.989L23.3 8.216a1.731 1.731 0 000 2.473c.692.692 1.83.692 2.472 0l2.869-2.819z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "34",
    "height": "34",
    "viewBox": "0 0 34 34",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};